
  import createMeisterIcons from '../src/createMeisterIcons';

  const MicEmpty = createMeisterIcons("mic-empty", [["path",{"fill":"currentColor","d":"M12 5.75c-1.286 0-2.25.964-2.25 2.25v4c0 1.286.964 2.25 2.25 2.25 1.186 0 2.25-1.064 2.25-2.25V8c0-1.286-.964-2.25-2.25-2.25M15.75 12c0 1.759-1.323 3.305-3 3.67v2.58H15a.75.75 0 0 1 0 1.5H9a.75.75 0 0 1 0-1.5h2.25v-2.57c-1.739-.336-3-1.824-3-3.68V8c0-2.114 1.636-3.75 3.75-3.75S15.75 5.886 15.75 8z","key":"eb82e707d983b0cf4bb58d6f6315da585351df3a","fillRule":"evenodd","clipRule":"evenodd"}]])

  export default MicEmpty
  